module.exports = __webpack_public_path__ + "img/badge_pautions_statut.260f8837.svg";